import React, { useState, useEffect } from "react";
import {  ResponsiveContainer } from "recharts";


function OverallPlanComplete() {
  const [planData, setPlanData] = useState(null);

  useEffect(() => {
    fetch('https://malaria-api.ddc-malaria.org/mhealth/getChartOverallPlanCompleteToday/fs_year') // Replace with your actual API endpoint
      .then(response => response.json())
      .then(data => setPlanData(data.overall_plan_complete)) // Extract relevant data
      .catch(error => console.error('Error fetching data:', error));
  }, []);

  const calculatePercentageChange = () => {
    if (!planData) return 0;
    return Math.round(((planData.total_this_month - planData.total_last_month) / planData.total_last_month) * 100);
  };

  return (
    <ResponsiveContainer width="100%" height={300}> 
    <div className="overall-plan-complete">
      {planData ? (
        <>
          <div className="plan-count">
            {planData.total_this_month}
          </div><br/><br/>
          <div className="plan-description">Overall Plans Completed</div>
          <br/><br/>
          <div className="plan-change">
            {calculatePercentageChange() > 0 ? ( 
                <span className="positive-change">&#x2191; {calculatePercentageChange()}%</span>
            ) : calculatePercentageChange() < 0 ? ( 
                <span className="negative-change">&#x2193; {Math.abs(calculatePercentageChange())}%</span> 
            ) : null}                              

            <span className="separator">&bull;</span> 
            <span className="last-month">was {planData.total_last_month} last month</span>
            </div>
        </>
      ) : (
        <div>Loading...</div> // Show loading state while data is fetched
      )}
    </div>
    </ResponsiveContainer>
  );
}

export default OverallPlanComplete;
